import TransportationTranslationResponse from '../data-models/TransportationTranslationResponse.DataModel';
import { apiGet } from '../support/helpers/ApiConnection.Helper';

export default function getAllTtSchedules(
    referralId: number,
    abortSignal: AbortSignal,
): Promise<Array<TransportationTranslationResponse>> {
    return apiGet<Array<TransportationTranslationResponse>>('/referral-tt-schedule/' + referralId, abortSignal);
}
